import React, { useEffect, useRef, useState } from 'react';

import s from './LoadingAssistantMessage.module.scss';
import { Text } from '@wix/design-system';
import { Theme } from '../../../types';
import cs from 'classnames';

interface LoadingAssistantMessageProps {
  dataHook?: string;
  statusMessage?: string;
  theme: Theme;
}

export const LoadingAssistantMessage: React.VFC<
  LoadingAssistantMessageProps
> = ({ dataHook, statusMessage, theme }) => {
  const [minHeight, setMinHeight] = useState(20);
  const divRef = useRef(null);

  useEffect(() => {
    adjustMinHeight();
  }, [statusMessage]);

  const adjustMinHeight = () => {
    if (divRef.current) {
      const height = (divRef.current as any).scrollHeight;
      if (height > minHeight) {
        setMinHeight(height);
      }
    }
  };
  return (
    <div
      className={cs(s.container, { [s.themeDark]: theme === 'dark' })}
      ref={divRef}
      style={{ minHeight: `${minHeight}px` }}
    >
      {theme === 'original' && (
        <div className={s.dots} data-hook={dataHook}>
          <div className={s.dot}></div>
          <div className={s.dot}></div>
          <div className={s.dot}></div>
        </div>
      )}
      <Text className={s.status} skin="disabled" light secondary>
        {statusMessage}
      </Text>
    </div>
  );
};
